/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {WealthyEnv} from "helpers";

const WealthyLogo = `${WealthyEnv.CDN_URL}/wealthy-home-page/wealthy-purple-logo.webp`;

const propTypes = {
  handlePush: PropTypes.func.isRequired,
  scrollPosition: PropTypes.number.isRequired
};

const Header = ({
  scrollPosition,
  handlePush
}) => {
  return (
    <Nav
      style={scrollPosition > 1 && window.screen.width <= 500
        ? {
          boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px"
        }
        : {}}
    >
      <NavLogo alt="wealthy-logo" src={WealthyLogo}  onClick={handlePush} />
    </Nav>
  );
};

const Nav = styled.div`
  width: 100%;
  height: 7rem;
  display: flex;
  align-items: end;
  position: relative;
  top: 0;
  cursor: pointer;

  @media (max-width: 768px) {
    height: 6.5rem;
    position: fixed;
    top: 0;
    z-index: 99;
    cursor: pointer;
  }
`;

const NavLogo = styled.img`
  height: 6rem;
  margin-top: 3rem;
  margin-left: 5rem;

  @media (max-width: 768px) {
    height: 4.5rem;
    margin-top: 2rem;
    margin-left: 2.5rem;
  }
`;

Header.propTypes = propTypes;

export default Header;
